"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAMP_API_ENDPOINTS = exports.RAMP_BASE_API = void 0;
exports.RAMP_BASE_API = `https://api.ramp.network/api`;
exports.RAMP_API_ENDPOINTS = {
    COUNTRIES: "/host-api/countries",
    // onramp
    ONRAMP_ASSETS_V3: "/host-api/v3/assets",
    ONRAMP_QUOTE_V3: "/host-api/v3/onramp/quote/all",
    // offramp
    OFFRAMP_ASSETS_V3: "/host-api/v3/offramp/assets",
    OFFRAMP_QUOTE_V3: "/host-api/v3/offramp/quote/all",
};
//# sourceMappingURL=constants.js.map